import { Alert, Grid } from '@arco-design/web-react';
import DOMPurify from 'dompurify';

const { Row, Col } = Grid;

// MUI -> Arco. Grid -> Arco Grid (/12 -> /24); Alert -> Arco Alert (type/
// content). makeStyles is dropped (the only style was unused). contentStyle is
// now a style object applied via `style`.
export default function TextViewer(props) {
    const { htmlContent, contentStyle } = props;
    const sanitizedHtml = DOMPurify.sanitize(htmlContent);

    return (
        <Row>
            <Col span={24}>
                <Alert type="info" content="Most recipients use email clients that support HTML (gmail, yahoo, outlook, etc). This is what they'll see." />
            </Col>
            <Col span={24}>
                <div style={contentStyle} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
            </Col>
        </Row>
    )
}
